<template>
	<v-expansion-panel>
		<v-expansion-panel-header expand-icon="" color="secondary">
			<v-toolbar rounded color="secondary" elevation="0" :outlined="false" dense class="pt-0 pb-0 mr-0 ml-0 font-weight-bold white--text justify-center text-center"
				><v-spacer></v-spacer><v-toolbar-title class="justify-center text-center" style="font-size: 32px">{{ title }}</v-toolbar-title
				><v-spacer></v-spacer
			></v-toolbar>
		</v-expansion-panel-header>
		<v-expansion-panel-content class="mx-auto justify-center text-center ml-5 mr-5 mt-5">
			<v-card-text class="justify-center text-center">
				<v-row class="justify-left text-center">
					<v-col v-for="file in files" :key="'file[' + file.path + ']'" cols="6">
						<v-card elevation="5" outlined>
							<input
								v-show="false"
								:ref="'file_input_' + file.path"
								type="file"
								hide-details
								:prepend-icon="false"
								@change="file.handleImage($event.target.files[0])"
							/>
							<v-toolbar color="primary" elevation="0" :outlined="false" dense class="pt-0 pb-0 mr-0 ml-0 font-weight-bold white--text justify-center text-center"
								><v-spacer></v-spacer><v-toolbar-title class="justify-center text-center" style="font-size: 32px"> {{ file.path }} </v-toolbar-title
								><v-btn absolute icon color="black" :loading="file.downloadingToUser" @click="() => {}"><v-icon>cloud_download</v-icon></v-btn
								><v-spacer></v-spacer
							></v-toolbar>
							<v-card color="grey" elevation="3" class="mx-auto pt-2" min-height="250px" min-width="100px" @click="file.onClickInput('file_input_' + file.path)">
								<v-img v-if="file.state == 'done'" min-height="300px" min-width="100px" :src="file.src ? file.src : null"></v-img>
								<h3 v-if="file.state == 'downloading'" min-height="300px" min-width="100px">Downloading [{{ file.path }}]</h3>
								<h3 v-if="file.state == 'error'" min-height="300px" min-width="100px">Failed to download</h3>
								<h3 v-if="file.state == 'error'" min-height="300px" min-width="100px">{{ file.error }}</h3>
							</v-card>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
// import { bus } from '@/main'
import axios from 'axios';
import store from '@/store';

export default {
	name: 'AdminViewPracticeDocumentsCard',
	components: {},
	props: {
		company: { type: Object, optional: false, required: true },
	},
	data: () => ({
		title: 'Documents',
		readonly: {},
		files: {
			logo: {
				src: false,
				path: 'logo',
				promise: null,
				error: 'false',
				state: 'idle',
				downloadingToUser: false,
				file: null,
				handleImage(fileObject) {
					const reader = new FileReader();

					reader.onload = e => {
						this.files['logo'].file = e.target.result;
					};
					reader.readAsDataURL(fileObject);
				},
				onClickInput(file) {
					this._this.$refs[file][0].click();
				},
			},
			imageA: {
				src: false,
				path: 'imageA',
				promise: null,
				error: 'false',
				state: 'idle',
				downloadingToUser: false,
				file: null,
				handleImage(fileObject) {
					const reader = new FileReader();

					reader.onload = e => {
						this.files['imageA'].file = e.target.result;
					};
					reader.readAsDataURL(fileObject);
				},
				onClickInput(file) {
					this._this.$refs[file][0].click();
				},
			},
			imageB: {
				src: false,
				path: 'imageB',
				promise: null,
				error: 'false',
				state: 'idle',
				downloadingToUser: false,
				file: null,
				handleImage(fileObject) {
					const reader = new FileReader();

					reader.onload = e => {
						this.files['imageB'].file = e.target.result;
					};
					reader.readAsDataURL(fileObject);
				},
				onClickInput(file) {
					this._this.$refs[file][0].click();
				},
			},
			imageC: {
				src: false,
				path: 'imageC',
				promise: null,
				error: 'false',
				state: 'idle',
				downloadingToUser: false,
				file: null,
				handleImage(fileObject) {
					const reader = new FileReader();

					reader.onload = e => {
						this.files['imageC'].file = e.target.result;
					};
					reader.readAsDataURL(fileObject);
				},
				onClickInput(file) {
					this._this.$refs[file][0].click();
				},
			},
		},
	}),
	mounted() {
		this.$nextTick(() => {
			const token = store.getters.jwtToken;
			const header = { headers: { Authorization: token } };

			Object.keys(this.files).forEach(file => {
				this.files[file]._this = this;
				this.files[file].state = 'downloading';
				this.files[file].promise = axios
					.get(store.getters.getDOCUMENTS + '/images/' + this.files[file].path + '/' + this.company.id, header)
					.then(result => {
						this.files[file].src = 'data:image/png;base64,' + result.data.data;
						this.files[file].state = 'done';
					})
					.catch(err => {
						this.files[file].error = err;
						this.files[file].state = 'error';
					});
			});
		});
	},
	methods: {
		edit(key) {
			Object.keys(this.readonly)
				.filter(k => k != key && !this.readonly[k])
				.forEach(k => this.finished(k));
			this.readonly[key] = false;
			this.$forceUpdate();
		},
		finished(key) {
			if (Object.keys(this.readonly).find(k => k == key)) {
				this.readonly[key] = true;
			} else {
				console.error("unknown readonly key '" + key + "'");
			}
			this.$forceUpdate();
		},
	},
};
</script>
